export default class Menu {
    constructor() {
        if (document.querySelectorAll('header.mobile .hamburger').length > 0) {
            document.querySelector('header.mobile .hamburger').addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                document.querySelector('header.mobile .menu-items').classList.toggle('active');
            });
            document.querySelector('header.mobile .menu-items .close-me').addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                document.querySelector('header.mobile .menu-items').classList.toggle('active');
            });


            document.querySelectorAll('header.mobile .menu-items .links .menu-item').forEach((item) => {
                item.addEventListener('click', (e) => {
                    document.querySelector('header.mobile .menu-items').classList.remove('active');
                });
            });


        }

        window.addEventListener('scroll', function () {
            if (this.window.innerWidth > 998) {

                var header = document.getElementsByTagName('header')[0];

                if (header == undefined) {
                    return;
                }
                let sticky = 100;
                if (document.querySelector('.target-about'))
                {
                    sticky += document.querySelector('.target-about').offsetHeight;
                }

                let logoNewSrc = '';

                if (window.scrollY > sticky) {
                    header.classList.add('sticky');
                    logoNewSrc = header.querySelector('.left-logo img').getAttribute('data-logo_c');
                } else {
                    logoNewSrc = header.querySelector('.left-logo img').getAttribute('data-logo_w');
                    header.classList.remove('sticky');
                }

                if (logoNewSrc != undefined && logoNewSrc != header.querySelector('.left-logo img').getAttribute('src')) {
                    header.querySelector('.left-logo img').setAttribute('src', logoNewSrc);
                }
            }
        });

        if (document.querySelector('header .top-social-menu .languages span'))
        {

            document.querySelector('header .top-social-menu .languages span').addEventListener('click', (e) => {
                if (document.querySelector('header .top-social-menu .languages').classList.contains('opened')) {
                    document.querySelector('header .top-social-menu .languages').classList.remove('opened');
                } else {
                    document.querySelector('header .top-social-menu .languages').classList.add('opened');
                }
            });
        }

        document.querySelectorAll('[data-open_submenu_id]').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = item.getAttribute('data-open_submenu_id');

                const targetElement = document.querySelector('[data-submenu_id="' + targetId+ '"]');

                if (targetElement) {

                    if (targetElement.classList.contains('d-none')) {
                        targetElement.classList.remove('d-none');
                    } else {
                        targetElement.classList.add('d-none');
                    }

                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });

        document.addEventListener('click', (event) => {
            const target = event.target;

            let hasOpenedMenus = false;
            const openMenus = document.querySelectorAll('[data-submenu_id]');
            openMenus.forEach((menu) => {
                if (!menu.classList.contains('d-none')) {
                    hasOpenedMenus = true;
                }
            });

            if (hasOpenedMenus && target.getAttribute('data-open_submenu_id')) {
                return;
            }

            openMenus.forEach((menu) => {
                if (menu.contains(target)) {
                    return;
                } else {
                    if (!menu.classList.contains('d-none')) {
                        menu.classList.add('d-none');
                    }
                }
            });
        });

    }

}
